import React from "react";

import ObjectAnalytics from "../components/ObjectAnalytics";
import { ANALYTICS_TABLE_NAME } from "../utils/const";

const Analytics: React.FC = () => {
  return (
    <ObjectAnalytics tableName={ANALYTICS_TABLE_NAME} />
  )
}

export default Analytics;